{
  "id": "maize",
  "name": "Maize",
  "species": "Zea mays",
  "ploidy": 2,
  "assembly": "Zm-B73-REFERENCE-NAM-5.0",
  "chromosomes": [
    "chr1",
    "chr2",
    "chr3",
    "chr4",
    "chr5",
    "chr6",
    "chr7",
    "chr8",
    "chr9",
    "chr10"
  ],
  "keys": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10"
  ],
  "pattern": "^(?:chr|chromosome)?[_\\s-]?0*([1-9]|10)$",
  "sources": [
    "https://ftp.ncbi.nlm.nih.gov/genomes/all/GCF/902/167/145/GCF_902167145.1_Zm-B73-REFERENCE-NAM-5.0/GCF_902167145.1_Zm-B73-REFERENCE-NAM-5.0_assembly_report.txt",
    "https://rest.ensembl.org/info/assembly/zea_mays"
  ]
}
